import { render, staticRenderFns } from "./phoneService.vue?vue&type=template&id=2c0176b7&scoped=true&"
import script from "./phoneService.vue?vue&type=script&lang=js&"
export * from "./phoneService.vue?vue&type=script&lang=js&"
import style0 from "./phoneService.vue?vue&type=style&index=0&id=2c0176b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0176b7",
  null
  
)

export default component.exports